<template>
  <div class="i-team-multi-picker">

    <i-multi-picker
      label-counter="team(s)"
      :label="label"
      :value="value"
      :fetch-options="fetchTeams"
      option-label="name"
      option-value="teamId"
      @input="$val => $emit('input',$val)"
    />
  </div>
</template>

<script>
import {listTeams} from "@/services/api/app/office/recovery/team/team";
import IMultiPicker from "@/components/common/forms/IMultiPicker.vue";

export default {
  name: 'ITeamMultiPicker',
  components: {IMultiPicker},
  props: {
    value: {},
    label: {
      type: String,
      default: "Teams & Groups"
    },
    placeholder: {
      type: String,
      default: 'Search all teams & groups'
    },
  },

  data() {
    return {
      selected: null,
      teams: []
    }
  },

  methods: {
    fetchTeams({search}) {

      return listTeams({
        pagination: {
          pageNumber: 1,
          pageSize: 300,
          sortBy: 'name',
          sortDescending: false
        },
        search,
        filter: {
          "statuses": [
            1, 2, 4
          ]
        }
      })
        .then(({result}) => {
          return result
        })
    },
  },

}
</script>

<style lang="scss">
@import "IUserMultiPicker";
</style>
